import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import AppsResource from "./AppsResources";
import BlogsResources from "./BlogsResources";
import FAQ from "./FAQ";
import ResourcesOverview from "./ResourcesOverview";
import Testimonials from "./Testimonials";

const NAV_OFFSET = 72;

const scrollToSection = (hash: string) => {
  if (!hash) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.querySelector(hash);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

const Resources = () => {
  const location = useLocation();

  useEffect(() => {
    // Small delay lets the page paint before scrolling
    const timer = setTimeout(() => {
      scrollToSection(location.hash);
    }, 80);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <section id="overview">
        <ResourcesOverview />
      </section>

      <section id="blogs">
        <BlogsResources />
      </section>

      <section id="testimonials">
        <Testimonials />
      </section>

      <section id="apps">
        <AppsResource />
      </section>

      <section id="faq">
        <FAQ />
      </section>
    </>
  );
};

export default Resources;
